"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var client_1 = require("@apollo/client");
var initPayment_1 = require("../../../graphql/mutations/initPayment");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var webpayStyles_1 = require("./webpayStyles");
var paymentApiWebpay_1 = require("../../../api/paymentApiWebpay");
var collectedFilters_1 = require("../../../../../../common/service/collectedFilters");
var Webpay_1 = require("./Webpay");
var errorHandler_1 = require("../../../../../common/service/errorHandler");
var clsx_1 = require("clsx");
var useCheckoutContext_1 = require("../../../../../common/hooks/useCheckoutContext");
var WebpayContainer = function (_a) {
    var deal = _a.deal;
    var styles = webpayStyles_1.default();
    var paymentType = useCheckoutContext_1.default().paymentType;
    var _b = client_1.useMutation(initPayment_1.default.INITIALIZE_PAYMENT), initPayment = _b[0], loading = _b[1].loading;
    var _c = react_1.useState(null), initError = _c[0], setInitError = _c[1];
    var _d = react_1.useState(false), softLocked = _d[0], setSoftLocked = _d[1];
    var _e = react_1.useState(false), btnLoading = _e[0], setBtnLoading = _e[1];
    var token = collectedFilters_1.default().filters.token;
    var handlePayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInitError(null);
                    setBtnLoading(true);
                    return [4 /*yield*/, initPayment({
                            variables: {
                                identifier: token,
                                paymentType: paymentType,
                            },
                        })
                            .then(function (transaction) {
                            var _a = transaction.data.initPayment, id = _a.id, url = _a.url;
                            setBtnLoading(false);
                            paymentApiWebpay_1.paymentApiWebpay.initializePaymentTransaction(id, url);
                        })
                            .catch(function (e) {
                            var _a;
                            var setSoftLockedError = errorHandler_1.default.handleSoftLock(e);
                            setBtnLoading(false);
                            setInitError(e);
                            setSoftLocked((_a = setSoftLockedError) === null || _a === void 0 ? void 0 : _a.isStockLocked);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    return (<core_1.Box>
      <Webpay_1.default initError={initError} loading={loading} deal={deal} softLocked={softLocked}/>
      <DefaultButton_1.default className={[clsx_1.default(styles.payButton, softLocked && styles.hidePaymentButton)]} dataTest="button:checkout:webpay" variant="contained" onClick={handlePayment} disabled={btnLoading}>
        <Translation_1.default id="trans__checkout__payment_page__pay_CTA"/>
      </DefaultButton_1.default>
    </core_1.Box>);
};
exports.default = WebpayContainer;
